import React, { Component, Fragment } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import CopyIcon from 'material-ui/svg-icons/content/content-copy';
import Snackbar from 'material-ui/Snackbar';

class ShareDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSnackbar: false
    }
  }

  copyToClipboard = () => {
    this.urlTextField.select();

    try {
      var successful = document.execCommand('copy');

      if (successful) {
        this.setState({showSnackbar: true})
      }
    } catch (err) {

    }
  }

  closeSnackbar = () => {
    this.setState({showSnackbar: false})
  }

  render() {
    let shareActions = [
      <FlatButton
        label="Close"
        onClick={this.props.onRequestClose}
      />
    ];

    const dialogContentStyle = {
      width: '360px'
    }

    return (
      <Fragment>
        <Dialog
          title="Share Incidents"
          contentStyle={dialogContentStyle}
          actions={shareActions}
          modal={false}
          open={this.props.open}
          onRequestClose={this.props.onRequestClose}
        >
          <TextField
            ref={textField => {
              this.urlTextField = textField;
            }}
            value={this.props.url}
            floatingLabelText="Share URL"
          />
          <IconButton
            onClick={this.copyToClipboard}
            tooltip="Copy to clipboard"
          >
            <CopyIcon />
          </IconButton>
        </Dialog>
        <Snackbar
          open={this.state.showSnackbar}
          message="Copied to clipboard"
          autoHideDuration={3000}
          onRequestClose={this.closeSnackbar}
        />
      </Fragment>
    )
  }
}

export default ShareDialog;
